import React, { useState, useRef, useEffect } from 'react'

import styled, { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme, GlobalStyles } from '../themes.js'
import './styles/services.scss'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import warehouse from '../assets/img/warehouse.png'
import container from '../assets/img/container.jpg'

gsap.registerPlugin(ScrollTrigger);

function Services(themeData) {

  useEffect(() => {
    document.title = 'Services • IBIS GlobaLink Co., Ltd..';
  }, []);

    return (
        <ThemeProvider theme={themeData.theme === 'light' ? lightTheme : darkTheme}>
        <GlobalStyles />
        <div id='services'>

          <section className="services section-top">
            <div className='pagetopMargin'></div>
            <div className="wrapper">
                <div className="flex flex-column">
                    <span className="title">Services</span>
                </div>
            </div>

            <div className='wrapper'>
              <div className='type-container'>
                <span className='type'>What is IBIS 3PL service?</span>
              </div>
            </div>

            <div className='wrapper'>
              <div className='pl'>
                <div className='left'>
                  <p>To conduct international logistics operations, it is essential to arrange trucks and drivers to transport goods, warehouses to temporarily store goods, export procedures on your behalf, and a system to manage the logistics.</p>
                  <p>If you are importing goods and asking each manufacturer to make individual arrangements, it will be expensive and time-consuming, and may hinder the execution of your business.</p>
                  <p>By letting IBIS handle everything for you, we promise to dramatically change your logistics operations.</p>
                </div>
                <div className='right'>
                  <lord-icon
                      src="https://cdn.lordicon.com/byupthur.json"
                      trigger="loop"
                      delay="2000"
                      colors="primary:#ef8746,secondary:#48a0df"
                      style={{ width: "200px", height: "200px" }}>
                  </lord-icon>  
                </div>
              </div>
            </div>
            
          </section>

          {/* <section className='blue'>
          </section> */}

          <section className='orange'>
            <div className='wrapper services-holder'>
              <span>Please contact us!</span>
              <span>We will continue to support you to the limit.</span>

              <div className='services-container'>
                <div className='each-service'>
                  <span className='service-title'>Considering reviewing logistics costs.</span>
                  <div className='service-hr'></div>
                  <span className='service-body'>If you have any doubts or are dissatisfied with your forwarder's prices, please contact us at and compare our prices with those we offer.</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Looking for a reliable logistics partner.</span>
                  <div className='service-hr'></div>
                  <span className='service-body'>We have a team that is well versed in ship components and can provide services from the standpoint of the shipowner.</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Concerned about exporting dangerous goods & complicated procedures.</span>
                  <div className='service-hr'></div>
                  <span className='service-body'>Exporting marine supplies is very complicated. Our experience allows us to respond quickly.</span>
                </div>
              </div>

            </div>
          </section>

          <section className='flow'>
            <div className='wrapper flow-holder'>
              <div className='type-container'>
                <span className='type'>IBIS Business Flow</span>
              </div>

              <div className='services-container'>
                <div className='each-service'>
                  <span className='service-title'>Delivery</span>
                  <span className='service-body'> From Supplier A <br />  From Supplier B <br /> From Supplier C</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Inspect</span>
                  <span className='service-body'>By warehouses manager</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Storage</span>
                  <span className='service-body'>Safe keeping</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Customs</span>
                  <span className='service-body'>By IBIS</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Export</span>
                  <span className='service-body'>By air or sea</span>
                </div>
                <div className='each-service'>
                  <span className='service-title'>Suppy</span>
                  <span className='service-body'>To the vessel</span>
                </div>

              </div>

            </div>
          </section>

          <section className='service-title'>
            <div className="wrapper">
                <div className="flex flex-column">
                    <span className="service-main-title">IBIS Business Scope</span>
                </div>
            </div>
          </section>

          <section className='scope'>
            <div className='bg-image'>
              <img src={warehouse} alt="Warehouse Image" />
            </div>
            
            <div className='scope-container'>
              <div className='wrapper'>
                <div className='scope-holder'>
                  <div className='each-scope'>
                    <div className='scope-title'>1. Export Packing</div>
                    <div className='scope-body'>
                      <p>Do you have trouble with export packing ?</p>
                      <p>We can take care of export fumigation packing on behalf of manufacturers who do not offer export packing services.</p>
                      <p>For overseas transportation, sturdy packing is necessary to prevent loss or damage. Especially in the case of shipping by ship, it is necessary to take proper measures for long distances and long hours.</p>
                    </div>
                  </div>
                  <div className='each-scope'>
                    <div className='scope-title'>2. Warehousing</div>
                    <div className='scope-body'>
                      <p>We manage the cargo purchased by our customers from other companies in our warehouse and take care of it responsibly until the timing of shipment.</p>
                      <p>We also offer long-term storage at a reasonable price.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>

          <section className='scope scope-blue'>
            <div className='bg-image'>
              <img src={warehouse} alt="Warehouse Image" />
            </div>
            <div className='bg-blue'></div>
            
            <div className='scope-container'>
              <div className='wrapper'>
                <div className='scope-holder'>
                  <div className='each-scope'>
                    <div className='scope-title'>3. Export Procedures</div>
                    <div className='scope-body'>
                      <p>We handle all export customs clearance procedures such as invoices and packing lists on your behalf.</p>
                    </div>
                  </div>
                  <div className='each-scope'>
                    <div className='scope-title'>4. Transportation</div>
                    <div className='scope-body'>
                      <p>We use airplanes, ships, and international courier services such as DHL and FEDEX to provide accurate shipping instructions and deliver your goods to the destination in the shortest possible time.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>

          <section className='scope'>
            <div className='bg-image'>
              <img src={container} alt="Warehouse Image" />
            </div>
            
            <div className='scope-container'>
              <div className='wrapper'>
                <div className='scope-holder'>
                  <div className='each-scope'>
                    <div className='scope-title'>5. Domestic Loading Agent</div>
                    <div className='scope-body'>
                      <p>We provide an agent service for loading marine supplies onto vessels arriving at ports throughout Japan.</p>
                      <p>We make full use of our nationwide network to ensure prompt delivery in accordance with the timing of vessel arrival.</p>
                    </div>
                  </div>
                  <div className='each-scope'>
                    <div className='scope-title'>6. Alliance Agreements with Overseas Logistics Companies</div>
                    <div className='scope-body'>
                      <p>We can also help support exports from Japan through alliance agreements with our peers.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>

          <section className='scope scope-orange'>
            <div className='bg-image'>
              <img src={warehouse} alt="Warehouse Image" />
            </div>
            <div className='bg-orange'></div>
            
            <div className='scope-container'>
              <div className='wrapper'>
                <div className='scope-holder'>
                  <div className='each-scope'>
                    <div className='scope-title'>7. Licensing Service for Export Application</div>
                    <div className='scope-body'>
                      <p>We provide application services on behalf of when you need to apply for a permit or other necessary procedures when exporting.</p>
                    </div>
                  </div>
                  <div className='each-scope'>
                    <div className='scope-title'>8. Logistics Solutions</div>
                    <div className='scope-body'>
                      <p>Please do not hesitate to contact us with any concerns you may have regarding logistics.</p>
                      <p>We will make the best use of our experience to provide you with the greatest possible support. If we don't know the answer to your question, we will check with our experienced partner companies and try our best to give you an appropriate answer.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>

          <section className='csr'>
            <div className='wrapper'>
              <div className='type-container'>
                <span className='title'>IBIS CSR</span>
                <span className='type'>We are committed to the following Corporate Social Responsibilty activities:</span>
              </div>

              <div className='csr-container'>
                  <div className='csr-left'>
                    <span><b>As a small and medium-sized company.</b></span>
                    <p>We are committed to respect diversity among employees and business partners regardless of race, nationality, or gender. View business partners as fair and impartial partners, providing services that consider the customer first and foremost.</p>
                    <div className='icons-container'>
                      <lord-icon
                          src="https://cdn.lordicon.com/shcfcebj.json"
                          trigger="loop"
                          delay="2000"
                          colors="primary:#ef8746,secondary:#48a0df"
                          style={{ width: "200px", height: "200px" }}>
                      </lord-icon> 
                      <lord-icon
                          src="https://cdn.lordicon.com/ugejbvui.json"
                          trigger="loop"
                          delay="2000"
                          colors="primary:#ef8746,secondary:#48a0df"
                          style={{ width: "200px", height: "200px" }}>
                      </lord-icon> 
                    </div>
                  </div>
                  <div className='csr-right'>
                    <span><b>Initiatives as a logistics company.</b></span>
                    <p>Aiming for zero accidents in transportation. We will ensure safe and secure operations. We take a stable management system that does not make wrong supply. We will actively use environmentally friendly packaging materials that reduce CO2 emissions.</p>
                    <div className='icons-container'>
                      <lord-icon
                          src="https://cdn.lordicon.com/zruuduya.json"
                          trigger="loop"
                          delay="2000"
                          colors="primary:#ef8746,secondary:#48a0df"
                          style={{ width: "200px", height: "200px" }}>
                      </lord-icon> 
                      <lord-icon
                          src="https://cdn.lordicon.com/lncdwnyd.json"
                          trigger="loop"
                          delay="2000"
                          colors="primary:#ef8746,secondary:#48a0df"
                          style={{ width: "200px", height: "200px" }}>
                      </lord-icon> 
                    </div>
                  </div>
              </div>

            </div>
          </section>

        </div>
        </ThemeProvider>
        
    )
}

export default Services;